import { render } from "./CustomStudiesView.vue?vue&type=template&id=3a6a383c&scoped=true"
import script from "./CustomStudiesView.vue?vue&type=script&lang=js"
export * from "./CustomStudiesView.vue?vue&type=script&lang=js"

import "./CustomStudiesView.vue?vue&type=style&index=0&id=3a6a383c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6a383c"]])

export default __exports__